import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, MessageCircleIcon, AwardIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
const badges = [{
  icon: FlameIcon,
  label: 'Horneadas del día'
}, {
  icon: MessageCircleIcon,
  label: 'Atención directa'
}, {
  icon: AwardIcon,
  label: 'Recetas argentinas'
}];
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-night-900 px-4 pb-16 pt-12 sm:px-6 sm:pb-24 sm:pt-16" data-id="element-52" data-mp="12862k3i3uktp">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-aqua-400/10 blur-3xl" aria-hidden="true" data-id="element-53" data-mp="x8jj3cboo8cg" />
      <div className="relative mx-auto grid w-full max-w-6xl items-center gap-10 md:grid-cols-2 md:gap-14" data-id="element-54" data-mp="nbop96qcuw4i">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-55" data-mp="3d2torapbqmf2">
          <div className="flex items-center gap-3" data-id="element-56" data-mp="3j9k9t8cxxbej">
            <div className="h-px w-10 bw-gold-rule" aria-hidden="true" data-id="element-57" data-mp="3j6odtpknkwsq" />
            <span className="font-display text-[11px] uppercase tracking-[0.3em] text-gold-400" data-id="element-58" data-mp="3o6u8lem7yzf1">
              Costa Rica
            </span>
          </div>

          <h1 className="mt-6 font-display text-[38px] font-semibold uppercase leading-[1.05] tracking-tight text-white sm:text-[54px]" data-id="element-59" data-mp="3e8whmjcz6oiq">
            Empanadas Argentinas{' '}
            <span className="text-aqua-400" data-id="element-60" data-mp="358rdqj6zq89b">Premium</span> en Costa Rica
          </h1>
          <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-61" data-mp="35akmq552t4kh">
            Empanadas horneadas del día, con masa dorada, rellenos generosos y
            sabores clásicos + premium para disfrutar en casa, compartir o llevar
            a tu próxima reunión.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3" data-id="element-62" data-mp="2hljas7x1bbag">
            <CtaButton href={WHATSAPP_ORDER_LINK} track="whatsapp-hero-click" data-id="element-63" data-mp="2lk8ra9ddd8yb">
              Pedir por WhatsApp
            </CtaButton>
            <CtaButton href="#sabores" variant="outline" track="flavors-scroll-click" data-id="element-64" data-mp="nbbev44vul7x">
              Ver sabores
            </CtaButton>
          </div>

          <p className="mt-4 max-w-md text-[12.5px] leading-relaxed text-white/45" data-id="element-65" data-mp="id00cg3n7mjd">
            Consultá sabores disponibles, precios y coordinación de entrega o
            retiro por WhatsApp.
          </p>

          <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-2" data-id="element-66" data-mp="1b04cr652f356">
            {badges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[13px] font-medium text-white/60" data-id="element-67" data-mp="15zzubakljycb">
                <Icon className="h-4 w-4 text-aqua-400" aria-hidden="true" data-id="element-68" data-mp="x0324yz00hci" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.55,
        ease: 'easeOut',
        delay: 0.08
      }} className="relative" data-id="element-69" data-mp="3hrlk4hb3w58g">
          <div className="overflow-hidden rounded-3xl border border-white/10 bg-night-800 shadow-soft ring-1 ring-aqua-400/20" data-id="element-70" data-mp="21by0lbsix4ei">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/844e58bc-5c26-46d1-9f25-d4e8449a20c1.jpg" alt="Empanadas argentinas recién horneadas de Blue & White sobre pizarra oscura" className="h-60 w-full object-cover sm:h-80 md:h-[22rem]" loading="eager" data-id="element-71" data-mp="268odxrcy1lw8" />
            <div className="flex items-center justify-between border-t border-white/10 px-4 py-3" data-id="element-72" data-mp="2p0qqaqijyg0o">
              <div data-id="element-73" data-mp="2u03lpznhovev">
                <p className="font-display text-sm uppercase tracking-wider text-white" data-id="element-74" data-mp="2tyiq06pfv6ff">
                  Horneadas del día
                </p>
                <p className="text-xs text-white/50" data-id="element-75" data-mp="uok99b2z950g">
                  Clásicos y opciones premium
                </p>
              </div>
              <span className="rounded-full border border-gold-400/50 px-2.5 py-1 text-[11px] font-semibold text-gold-400" data-id="element-76" data-mp="4auo8pqfqxn9">
                Premium
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}